<template>
  <div>
    <div class="f f-gap-16">
      <input
        v-model="textInput"
        type="text"
        class="input-text"
        @keydown.tab.prevent="onTab"
        @keydown.enter="onEnter"
      >
      <button @click="addUsername" :class="{ button: true, disabled: usernames.length > 2 }">Add Username</button>
      <button ref="scrapeButton" @click="scrape" :class="{ button: true, disabled: !canScrape }">Fetch Lists</button>
    </div>
    <div class="f f-gap-8 m-tx2">
      <div
        v-for="(username, idx) in usernames"
        :key="idx"
        class="t-16 p-4 white bg-gray b-1-dark-gray br-2"
      >
        <span>{{ username }}</span>
        <span @click="deleteUsername(idx)" class="c-p m-lx1">x</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';

  const emit = defineEmits(['scrape']);

  const usernames = ref([]);
  const textInput = ref('');
  const scrapeButton = ref(null);

  // List management
  const addUsername = () => {
    usernames.value.push(textInput.value);
    textInput.value = '';
  }
  const deleteUsername = (idx) => {
    usernames.value.splice(idx, 1);
  };

  // Scraping
  const canScrape = computed(() => usernames.value.length > 0 && usernames.value.length < 4);
  const scrape = () => {
    if (canScrape.value) emit('scrape', usernames.value);
  };

  const onEnter = () => { addUsername() };
  const onTab = () => { scrapeButton.value.focus() };
</script>